// Loader Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Spinner } from '../../common/spinner'

class Loader extends Component {
  static get propTypes () {
    return {
      hidden: PropTypes.bool,
      size: PropTypes.number,
      color: PropTypes.string
    }
  }

  static get defaultProps () {
    return {
      hidden: false
    }
  }

  constructor (props) {
    super(props)

    this.state = {
      active: false
    }
  }

  makeActive () {
    this.setState({ active: true })
  }

  makeInActive () {
    this.setState({ active: false })
  }

  render () {
    const { size, color } = this.props
    return (
      <div>
        <div css={{
          display: this.state.active && !this.props.hidden ? 'flex' : 'none',
          justifyContent: 'center',
          marginTop: '30px',
          marginBottom: '30px'
        }}
        >
          <Spinner size={size} color={color} />
        </div>
      </div>
    )
  }
}

export default Loader
